module.exports = __webpack_public_path__ + "static/media/san-francisco.0746e42e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cities/san-francisco.jpg
// module id = 533
// module chunks = 0